import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { TabContainerDesktop } from './TabContainerDesktop';
import { TabContainerMobile } from './TabContainerMobile';

export interface ITab {
  isCompleted: boolean;
  isBeforeSelected?: boolean;
  isAfterSelected?: boolean;
  id: number | string;
  name: string;
  title: string;
  type?: string | number;
  isSelected: boolean;
  isMoreMagic?: boolean;
}

interface ITabContainerProps {
  tabs: Array<ITab>;
  onSelectedTab?(id?: number | string): void;
}

const mobile = css`
  @media (min-width: ${BREAKPOINT_SMALL}) {
    display: none;
  }
`;
const desktop = css`
  @media (max-width: ${BREAKPOINT_SMALL}) {
    display: none;
  }
`;

export const TabContainer = observer(({ tabs, onSelectedTab }: ITabContainerProps) => (
  <React.Fragment>
    <div className={mobile}>
      <TabContainerMobile tabs={tabs} onSelectedTab={onSelectedTab} />
    </div>
    <div className={desktop}>
      <TabContainerDesktop tabs={tabs} onSelectedTab={onSelectedTab} />
    </div>
  </React.Fragment>
));
